// extracted by mini-css-extract-plugin
export default {"badge":"ResultCorrectionBadge_badge__fVYpd","corrected":"ResultCorrectionBadge_corrected__vTxx0","superseded":"ResultCorrectionBadge_superseded__CONKP"};